<template>
  <div class="aggregator-status-item">
    <v-hover v-if="active">
      <template v-slot:default="{hover}">
        <div>
          <component :is="iconComponentName" class="aggregator-status-item_icon" :hover="hover" />
          <div
            class="aggregator-status-item_status"
            :class="{'aggregator-status-item_status__hover': hover}"
          ></div>
        </div>
      </template>
    </v-hover>

    <v-tooltip v-else bottom color="black">
      <template v-slot:activator="{ on, attrs }">
        <div
          v-bind="attrs"
          class="aggregator-status-item-icon"
          v-on="on"
        >
          <component :is="iconComponentName" />
        </div>
        <!--        <div
          class="aggregator-status-item_status aggregator-status-item_status__disabled"
        ></div>-->
      </template>
      Интеграция с {{ aggregatorName }} не активна
    </v-tooltip>
  </div>
</template>

<script>
  import AggregatorType from '@/models/enums/AggregatorType'
  import StatusIconYandex from '@/components/aside/aggregators-status/icons/StatusIconYandex.vue'
  import StatusIconDeliveryClub from '@/components/aside/aggregators-status/icons/StatusIconDeliveryClub.vue'
  import StatusIconSberMarket from '@/components/aside/aggregators-status/icons/StatusIconSberMarket.vue'
  import StatusIconChibis from '@/components/aside/aggregators-status/icons/StatusIconChibis.vue'
  import StatusIconKuper from '@/components/aside/aggregators-status/icons/StatusIconKuper.vue'
  import StatusIconJupiter from '@/components/aside/aggregators-status/icons/StatusIconJupiter.vue'

  export default {
    name: 'AggregatorStatusItem',
    comments: [
      StatusIconYandex,
      StatusIconDeliveryClub,
      StatusIconSberMarket,
      StatusIconChibis,
      StatusIconKuper,
    ],
    components: { StatusIconJupiter },
    props: {
      aggregator: {
        type: String,
        default: null,
      },
      active: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      iconComponentName () {
        switch (this.aggregator) {
          case AggregatorType.Yandex:
            return StatusIconYandex
          case AggregatorType.DeliveryClub:
            return StatusIconDeliveryClub
          case AggregatorType.SberMarket:
            return StatusIconKuper
          case AggregatorType.Chibis:
            return StatusIconChibis
          case 'jupiter':
            return StatusIconJupiter
          default:
            return null
        }
      },
      aggregatorName () {
        return AggregatorType.getName(this.aggregator)
      },
    },
  }
</script>

<style scoped lang="less">
.aggregator-status-item {
  width: 33px;
  height: 33px;
  color: white;
  position: relative;

  .media-xl({
    width: 42px;
    height: 42px;
  });

  &_status {
    width: 8px;
    height: 8px;
    background: #2a5a2b;
    border-radius: 50%;
    position: absolute;
    right: -3px;
    top: -3px;
    transition: all 0.3s ease;

    &__hover {
      background: @color-success;
      transform: scale(1.5);
    }

    &_icon {

    }

    &__disabled {
      background: @color-error;
    }
  }
}
</style>
